export default "__VITE_ASSET__BVNijrhd__"